import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Trophy from "../assets/Trophy.png";
import name from "../assets/firstName.png";
import { IoMdArrowDropdown } from "react-icons/io";
import Calender from "../Component/Calender";
import axios from "axios";
import { postRegisterurl } from "../Services/BackendUrl";
import { Toast } from "primereact/toast";
import { useFormData } from "../Context/FormContext";
import {
  validateName,
  validateEmail,
  validateDOB,
  validateGender,
  validateAddress,
//   validateCity,
//   validateState,
  validateCountry,
  validateCivilId,
  validateExpiryDate,
  validateFile, 
  validatePhone,
  validateWhatsapp,
//   validatePostal
} from "../utils/validation";

export const Membership = ({ errors: externalErrors, setErrors: externalSetErrors }) => {
	const toast = useRef(null);
	const { formData, setFormData, resetFormData } = useFormData();

	const [open, setOpen] = useState(false);
	const [localErrors, setLocalErrors] = useState({});
	const [showModal, setShowModal] = useState(false);
	const navigate = useNavigate();
	const errors = externalErrors ?? localErrors;
	const setErrors = externalSetErrors ?? setLocalErrors;


	const handleSubmit = async () => {
	const newErrors = {	
	firstName: validateName(formData.personalInformation.firstName, "First Name"),
	lastName: validateName(formData.personalInformation.lastName, "Last Name"),
	emailAddress: validateEmail(formData.personalInformation.emailAddress),
	dateOfBirth: validateDOB(formData.personalInformation.dateOfBirth),
	gender: validateGender(formData.personalInformation.gender),
	address: validateAddress(formData.personalInformation.address),
	// city: validateCity(formData.personalInformation.city),
	// state: validateState(formData.personalInformation.state),
	country: validateCountry(formData.personalInformation.country),
	civilIdNumber: validateCivilId(formData.personalInformation.civilIdNumber),
	idExpireDate: validateExpiryDate(formData.personalInformation.idExpireDate),
	phoneNumber: validatePhone(formData.personalInformation.phoneNumber),
	whatsAppNumber: validateWhatsapp(formData.personalInformation.whatsAppNumber),
	// zipcode: validatePostal(formData.personalInformation.zipcode),
		"Civil ID Image": validateFile(formData.civilIdImage, "Civil ID Image"),
		"Photo Proof": validateFile(formData.photoProof, "Photo Proof"),};
		if (!formData.emergencyDetails.emergencyContactFirstName?.trim()) {
			newErrors.emergencyContactFirstName = "Emergency contact name is required";
		}
		if (!formData.emergencyDetails.emergencyContactRelationship?.trim()) {
			newErrors.emergencyContactRelationship = "Relationship is required";
		}
		if (!formData.emergencyDetails.emergencyContactPhoneNumber?.trim()) {
			newErrors.emergencyContactPhoneNumber = "Emergency contact phone number is required";
		}
		if (!formData.medicalInformation.medicalCondition?.trim()) {
			newErrors.medicalCondition = "Medical condition is required";
		}
		if (
			formData.medicalInformation.medicalCondition === "Yes" &&
			!formData.medicalInformation.medicalConditionDetails?.trim()
		) {
			newErrors.medicalConditionDetails = "Please provide details for your condition";
		}
		if (!formData.medicalInformation.bloodGroup?.trim()) {
			newErrors.bloodGroup = "Please select your blood group";
		}
		if (!formData.membership.preferredStartDate) newErrors.preferredStartDate = "Please select a start date";
		if (!formData.membership.membershipType) newErrors.membershipType = "Please select membership type";

		setErrors(newErrors);

const hasErrors = Object.values(newErrors).some((msg) => msg);

if (hasErrors) return;
		  
		const data = {
			firstName: formData?.personalInformation?.firstName,
			lastName: formData?.personalInformation?.lastName,
			emailAddress: formData?.personalInformation?.emailAddress,
			phoneNumber: formData?.personalInformation?.phoneNumber,
			whatsAppNumber: formData?.personalInformation?.whatsAppNumber,
			dateOfBirth: formData?.personalInformation?.dateOfBirth,
			gender: formData?.personalInformation?.gender,
			address: formData?.personalInformation?.address,
			// address2: formData?.personalInformation?.address2,
			// city: formData?.personalInformation?.city,
			// state: formData?.personalInformation?.state,
			// zipcode: formData?.personalInformation?.zipcode,
			country: formData?.personalInformation?.country,
			civilIdNumber: formData?.personalInformation?.civilIdNumber,
			idExpireDate: formData?.personalInformation?.idExpireDate,
			emergencyContactFirstName: formData?.emergencyDetails?.emergencyContactFirstName,
			emergencyContactRelationship: formData?.emergencyDetails?.emergencyContactRelationship,
			emergencyContactPhoneNumber: formData?.emergencyDetails?.emergencyContactPhoneNumber,
			medicalCondition: formData?.medicalInformation?.medicalCondition,
			bloodGroup: formData?.medicalInformation?.bloodGroup,
			medicalConditionDetails: formData?.medicalInformation?.medicalConditionDetails,
			membershipType: formData?.membership?.membershipType,
			preferredStartDate: formData?.membership?.preferredStartDate
		}

		

		const registerFormdata = new FormData()
		registerFormdata.append("data", JSON.stringify(data));
		registerFormdata.append("photoProof", formData.photoProof)
		registerFormdata.append("civilIdImage", formData.civilIdImage)

		try {
			await axios.post(postRegisterurl, registerFormdata, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			setShowModal(true);
			document.body.style.overflow = "hidden";
		} catch (error) {
			const msg = error?.response?.data?.error?.message || "Something went wrong";

			const errorMessages = {
				"emailAddress already exists": "Email Address already exists",
				"whatsAppNumber already exists": "WhatsApp Number already exists",
				"phoneNumber already exists": "Phone Number already exists",
				"civilIdNumber already exists": "Civil ID Number already exists",
				"emergencyContactPhoneNumber already exists": "Emergency Contact Phone Number already exists",
			};

			const displayMessage = errorMessages[msg] || msg;

			toast.current.show({
				severity: "custom",
				summary: "error",
				content: (
					<div
						style={{
							backgroundColor: "#FF7F5077",
							width: "100%",
							padding: "20px",
							display: "flex",
							justifyContent: "flex-start",
							gap: "12px",
							alignItems: "center",
							color: "white",
							borderRadius: "6px",
						}}
					>
						<i
							className="pi pi-exclamation-triangle"
							style={{ fontSize: "1.5rem", padding: "20px" }}
						></i>
						<span>{displayMessage}</span>
					</div>
				),
			});
		}
	};

	const handleDone = () => {
		resetFormData();
		setShowModal(false);
		document.body.style.overflow = "auto";
		navigate("/registration");
	};

	const membershipOptions = [
		"ONE Hour Slot per player",
		"ONE Hour Slot, ONE Court, for max 6 players",
		"Weekly (5days), for ONE player",
		"Weekly (5 Days), ONE Court, for max 6 players",
		"Monthly (Excluding Week Ends), ONE player",
		"Monthly (Excluding Week Ends), ONE Court, for max 6 players",
		"Monthly, only Week-Ends (Fri & Sat), ONE Court, for max 6 player",
		"Yearly (Excluding Week Ends), ONE player",
		"Yearly (Excluding Week Ends), ONE Court, for max 6 players",
		"Yearly (Including Week Ends), ONE Court, for max 6 players",
	];

	return (
		<div className="contents">
			<Toast ref={toast} position="top-right" />
			<div className="contents">
				<div
					className={`${showModal ? "blur-sm" : ""
						} transition-all duration-300 contents`}
				>
						<div className="flex flex-col w-full gap-2 mt-2 lg:mt-0">
							<label className="text-[#FFFFFF] mb-1 text-[16px] lg:text-[20px]">
								Preferred Start Date
							</label>
							<div className="bg-[#282828] text-white px-6 py-5 rounded-full border-none w-full text-[14px] md:text-[18px]">
								<Calender
									value={formData.membership.preferredStartDate}
									onChange={(date) =>
										setFormData((prev) => ({
											...prev,
											membership: { ...prev.membership, preferredStartDate: date },
										}))
									}
									placeholder="YYYY-MM-DD"
									disablePast={true}
								/>
							</div>

							{errors.preferredStartDate && (
								<p className="text-red-500 text-sm">{errors.preferredStartDate}</p>
							)}
						</div>

						<div className="flex flex-col w-full gap-2 mt-2 lg:mt-0">
							<label className="text-white mb-1 text-[16px] md:text-[20px]">
								Type of Membership
							</label>
							<div className="relative">
								<div
									onClick={() => setOpen(!open)}
									className="flex items-center bg-[#282828] rounded-full px-6 py-4 gap-2 cursor-pointer"
								>
									<img
										src={name}
										alt="icon"
										className="w-5 h-5 sm:w-6 sm:h-6"
									/>
									<span className="text-white w-full text-[14px] lg:text-[18px] font-lufga">
										{formData.membership.membershipType || (
											<span className="text-[#949494]">Choose membership</span>
										)}
									</span>
									<span className="pointer-events-none absolute right-6 text-white">
										<IoMdArrowDropdown className="w-6 h-6" />
									</span>
								</div>

								{open && (
									<ul className="absolute z-10 w-full mt-2 bg-[#282828] rounded-xl border-b border-[#3D3D3D]">
										{membershipOptions.map((option, i) => (
											<ul
												key={i}
												onClick={() => {
													setFormData((prev) => ({
														...prev,
														membership: { ...prev.membership, membershipType: option },
													}));
													setOpen(false);
													setErrors((prev) => ({ ...prev, membershipType: "" }));
												}}
												style={{
													borderBottom: i !== membershipOptions.length - 1 ? "1px solid #3D3D3D" : "none",
													padding: "14px 24px",
													color: "#ffffff",
													cursor: "pointer",
												}}
												className="hover:bg-[#3a3a3a] text-[14px] sm:text-[16px]"
											>
												{option}
											</ul>
										))}
									</ul>
								)}
								{errors.membershipType && (
									<p className="text-red-500 text-sm mt-1">
										{errors.membershipType}
									</p>
								)}
							</div>
						</div>

						<div className="col-span-1 md:col-span-2 flex justify-center gap-6 mt-8">
							<button
								type="button"
								onClick={() => navigate("/registration/medicalinformation")}
								className="border border-solid border-[#D3631D] bg-transparent text-white px-10 py-2 rounded-full text-[24px] md:text-[30px] font-league hover:bg-[#1f1f1f] transition w-full sm:w-auto"
							>
								BACK
							</button>
							<button
								type="button"
								onClick={handleSubmit}
								className="bg-[#D3631D] cursor-pointer text-white px-10 py-2 rounded-full text-[24px] md:text-[30px] font-league border-none w-full sm:w-auto "
							>
								SUBMIT
							</button>
						</div>
				</div>

				<div
					className={`fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 transition-opacity duration-300 ${showModal ? "opacity-100 visible" : "opacity-0 invisible"
						}`}
				>
					<div className="relative bg-white rounded-xl p-6 sm:p-8 shadow-lg text-center w-full max-w-xs sm:max-w-sm pt-20 sm:pt-24 mx-4 transition-transform duration-300">
						<img
							src={Trophy}
							alt="Trophy"
							className="absolute flex items-center ml-14 md:ml-16 lg:ml-14 -top-16 sm:-top-28 md:-top-20 lg:-top-28 transform  w-32 h-32 md:w-40 md:h-40 lg:w-52 lg:h-60"
						/>
						<h2 className="text-lg sm:text-xl font-bold text-[#0C0C0C] mb-2 font-langit">
							SUCCESSFULLY SUBMITTED
						</h2>
						<p className="text-xs sm:text-sm text-[#949494] mb-6 px-2">
							You've successfully registered! We'll reach out to you shortly
							with more details.
						</p>
						<button
							onClick={handleDone}
							className="bg-[#D3631D] text-white px-6 py-2 rounded-full font-league border-none text-[12px] cursor-pointer"
						>
							DONE
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
